module.exports = __webpack_public_path__ + "static/media/Nevermore.6676d3e9.png";